module.exports = __webpack_public_path__ + "static/media/BannerActive.fe9f265c.svg";